import type { JssStyle } from 'jss';
import type { WebWidgetModel } from '@web/types';
import type { BeforeAfterWidgetData } from '@web/widgets/before-after/type/before-after-widget.type';
import { EHandleOrientation } from '@web/widgets/before-after/type/before-after-widget.type';

import { EHorizontalPosition, Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { BeforeAfterViewComponent } from '@web/widgets/before-after/components/before-after-view/before-after-view.component';
import { BeforeAfterControlComponent } from '@web/widgets/before-after/components/before-after-control/before-after-control.component';

const beforeAfterData: BeforeAfterWidgetData = {
    beforeImage: null,
    afterImage: null,
    horizontalAlign: EHorizontalPosition.L,
    handleOrientation: EHandleOrientation.vertical,
    handleColor: '#ffffff',
    handlePosition: 50,
    maxWidth: null,
};

const beforeAfterStyles: JssStyle = {};

export const beforeAfterWidgetModel: WebWidgetModel = {
    componentView: BeforeAfterViewComponent,
    componentControl: BeforeAfterControlComponent,
    name: Widgets.BEFORE_AFTER,
    label: 'widget_before_after_label',
    data: beforeAfterData,
    styles: beforeAfterStyles,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, type: ['default', 'specific'] },
};
